<template>
  <div id="app" class="wrapper" :class="$route.name">
      <div class="container"><router-view></router-view></div>
      <small class="desc">For more information please visit the <a href="https://curlythemes.com"> Curly Themes</a> website</small>
  </div>
</template>

<script>

export default {
  name: 'app',
  components: {
  }
}
</script>

<style lang="scss">
    @import '/assets/scss/main';
    .desc{
        opacity: 0.5;
        font-weight: 400;
    }
</style>
